import { Component, OnInit, Input } from '@angular/core';
import { breadCrumbsService } from '../../../core/services/breadCrumbs.service';

@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadCrumbs.component.html',
    styleUrls: ['./breadCrumbs.component.css'],
    providers: [breadCrumbsService]
})
export class BreadCrumbsComponent implements OnInit {

    @Input() key;
    linkParam: any;
    constructor(
        private breadCrumbs: breadCrumbsService
    ) {

    }
    ngOnInit() {
        this.linkParam = this.breadCrumbs.breadCrumbs[this.key];
    }

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/shared/components/breadCrumbs/breadCrumbs.component.ts